import { getIsFromBuilder } from './getIsFromBuilder';
import { getIsFromSeller } from './getIsFromSeller';
import { IState } from '../../store';

export const isNewbuildingAdvantagesEnabled = (state: IState): boolean => {
  const isFromBuilder = getIsFromBuilder(state);
  const isFromSeller = getIsFromSeller(state);

  return isFromBuilder || isFromSeller;
};
